import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ContactService } from 'src/app/contact/contact.service';

@Component({
  selector: 'app-newsletter',
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.scss'],
})
export class NewsletterComponent implements OnInit {
  public newsletterForm: FormGroup;
  public loadingNewsletter: boolean;
  public messageSent: boolean;
  public errorMessage: boolean;
  public showForm = true;
  constructor(private contactoService: ContactService) {}

  initForm() {
    this.newsletterForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  ngOnInit() {
    this.initForm();
  }


  subscribeNewsletter() {
    this.loadingNewsletter = true;
    this.contactoService.sendEmail(this.newsletterForm.value).subscribe(
      (res: any) => {
        this.loadingNewsletter = true;
        this.messageSent = true;
        this.showForm = false;
        setTimeout(function () {
          window.location.reload();
        }, 1000);
      },
      (err) => {
        console.log(err);
        this.loadingNewsletter = false;
        this.errorMessage = true;
      }
    );
  }
}
